import React, { Component } from 'react'
import './css/detail.css'
import event1 from '../../assets/image/event1.jpg'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import gallery1 from '../../assets/image/gallery1.jpg'
import gallery2 from '../../assets/image/gallery2.jpg'
import gallery3 from '../../assets/image/insight3.jpg'
import no_image from '../../assets/image/no_image.png'

import Gallery from '../../components/grid/gallery'
const data_gallery=[
    {
        title:'WINNING IN THE DIGITAL AGE',
        caption:'Kehadiran Professor Dave Ulrich, Father of Modern HR, untuk kelima kalinya sejak 2011, sukses menghidupkan acara Mega Seminar Winning in the Digital Age, yang diadakan oleh PT GML Performance Consulting bersama dengan Knowcap Event Organizer, selama dua hari tanggal 24 – 25 Oktober 2019, di Hotel JW Marriott.',
        img:gallery1
    },
    {
        title:'STELLAR WORKPLACE AWARD 2019',
        caption:'GML Performance Consulting bekerjasama dengan Kontan Business & Investment Media sebagai mitra riset, 25 Oktober 2019 kembali menggelar acara Stellar Workplace Award 2019, yang diadakan di Hotel JW Marriott Jakarta.',
        img:gallery2
    },
    {
        title:'HARI ANTI KORUPSI SEDUNIA (HAKORDIA) 2019',
        caption:'Knowcap sukses menyelenggarakan event Hari Anti Korupsi Sedunia (Hakordia) 2019, di kantor pusat DJP, Jakarta Selatan.Ada pun acara ini dihadiri langsung oleh Menteri Keuangan Sri Mulyani, Dirjen Pajak Suryo Utomo, dan Irjen Kementerian Keuangan Sumiyati. Selain itu sesi talkshow dihadiri juga oleh Najwa Shihab.Hakordia kali ini mengangkat tema “Tanpa Korupsi, Kemenkeu Kuat, Indonesia Maju”.',
        img:gallery3
    },
    {
        title:'',
        caption:'',
        img:no_image
    }
]
export default class documentation extends Component {
    state={
        photoIndex: 0,
        isOpen: false,
    }
    lightBoxToggle=(i)=>{
        this.setState({photoIndex:i,isOpen:!this.state.isOpen})
    }
    render() {
        const {photoIndex,isOpen}=this.state
        const {image}=this.props
        // console.log('image', image)
        return (
            <div>
               
                     {/* <Gallery image={data_gallery}/> */}
                <div className='grid-documentation'>
                    {image.map((img,i)=>(
                        <div className='image-documentation-overlay' onClick={()=>this.lightBoxToggle(i)}>
                            <img src={img.imageURL}/>
                        </div>
                    ))}
                </div>
                {isOpen && (
                    <Lightbox
                        mainSrc={image[photoIndex].imageURL}
                        // nextSrc={image[(photoIndex + 1) % image.length].img}
                        // prevSrc={image[(photoIndex + image.length - 1) % image.length].img}
                        imageCaption={image[photoIndex].caption}
                        // mainSrcThumbnail={image[photoIndex].caption}
                        // mainSrcThumbnail={image[(photoIndex + 1) % image.length].caption}
                        // nextSrcThumbnail={image[(photoIndex + image.length - 1) % image.length].caption}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                        onMovePrevRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + image.length - 1) % image.length,
                        })
                        }
                        onMoveNextRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + 1) % image.length,
                        })
                        }
                    />
                )}
            </div>
        )
    }
}
